import { useT } from "@/lib/i18n";

// A1 (30 Oct) — the gas-supply warning the Results page and PDF show, on the Report and shared pages.
export const CondFuelBanner = ({ result }) => {
  const t = useT();
  if (!result?.conditional_on_fuel_confirmation) return null;
  return (
    <section className="card p-5 mb-6" style={{ background: "#FFF4E6", borderColor: "#B45309", borderWidth: "1.5px" }}
             data-testid="cond-fuel-banner">
      <div className="overline" style={{ color: "#B45309" }}>{t("results.cond_fuel_overline")}</div>
      <h3 className="font-display text-lg mt-1" style={{ color: "#B45309" }} data-testid="cond-fuel-title">
        {t("results.cond_fuel_title")}
      </h3>
      <p className="text-sm mt-2" style={{ color: "#7a4408", lineHeight: 1.55 }}>{t("results.cond_fuel_body")}</p>
    </section>
  );
};
